import firebase from 'firebase/app';
import 'firebase/firestore';
import firebaseConfig from './data/db/prod';
import firebaseConfigDev from './data/db/dev';

const {
  NODE_ENV
} = process.env;

const isDev = NODE_ENV === 'development';
let config = firebaseConfig;

if ( isDev ) {
  config = firebaseConfigDev;
}

firebase.initializeApp(config);

const db = firebase.firestore();

// if ( isDev ) {
//   db.useEmulator( 'firebase', 8081 );
// }

export default db;